import { motion } from "framer-motion";

export default function HomeLogoAnimated() {

    const path = "M138.08,12.18c-12.24-11.11-33.86-16.8-48.64-7.53-7.9,4.94-11.63,15.71-9.27,24.65.18.7,1.03,3.38,1.41,3.82.45.52,1.24.39,1.29-.37.04-.89-.55-2.78-.62-3.88-.35-5.63.89-11.33,4.63-15.63t.01.01v45.3c0,1.66-.08,3.32-.35,4.96-.63,3.87-1.99,7.56-4.32,10.79-.45.63-3.11,3.8-3.65,3.84-.17.02-.32-.02-.44-.14-13.58-12.32-15.43-33.59-12.28-50.72,1.54-8.39,4.54-17.45,11.11-23.2.4-.48.14-1.02-.32-1.31-.32-.21-2.17.43-2.69.61-21.67,7.01-32.78,27.92-28.88,50.12,2.43,13.82,11.6,24.43,23.91,30.74l-6.24.63c-17.39,1.74-30.97-7.52-32.22-25.48l.02-50.97c.27-1.37,1.01-2.51,2.02-3.36,1-.84,2.27-1.41,3.6-1.62.93-.15,5.43.15,3.33-1.32H.47c-.52.08-.64.96-.19,1.1,2.08.06,4.21.08,6.08,1.1,1.89,1.03,3.13,2.94,3.25,5.12v50.55c2.15,28.71,38.6,34.22,61.14,28.7,1.2-.29,4.31-1.53,5.16-1.56.6-.03,3.93,1.15,4.88,1.38,20.11,4.89,45.45,1.48,60.15-14.1,16.25-17.25,14.57-46.4-2.85-62.21ZM116.53,79.73c-9,6.46-21.71,7.22-31.73,2.73-.01,0-.01-.01,0-.01,1.97-1.8,4.01-3.49,5.67-5.6,2.93-3.72,4.74-8.08,5.66-12.67.48-2.36.63-4.76.63-7.16l.02-50.49c.08-.12,1.04-.32,2.06-.52,1.01-.18,2.07-.35,2.35-.38,14.38-1.49,24.11,8.55,28.09,21.37,5.33,17.19,2.87,41.55-12.73,52.74Z";
    return (
        <motion.svg
            viewBox="0 0 152.19 90.57"
            width="600"
            className={"home-logo"}
        >

<motion.path
    d={path}

    fill="transparent"
    stroke="#f6a71d"
    strokeWidth="0.1"
    strokeLinecap="round"

    initial={{
        pathLength: 0,
        opacity: 0
    }}

    animate={{
        pathLength: 1,
        opacity: 1
    }}

    transition={{
        pathLength:{
            duration: 3,
            ease: [0.22,1,0.36,1]
        },
        opacity:{
            duration: .5
        }
    }}
/>

                    {/* GOLD FILL */}
        <motion.path
            d={path}

            stroke="none"
            fill="#f6a71d"

            initial={{
                opacity: 0
            }}

            animate={{
                opacity: 1
            }}

            transition={{
                delay: 1,
                duration: 0.8,
                ease: "easeOut"
            }}
        />



    </motion.svg>
    );
}